'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/event-stack.production.js');
} else {
  module.exports = require('./cjs/event-stack.development.js');
}